<app-sidebar
  #appSidebar
  [fixed]="true"
  [display]="'sm'"
  [minimized]="sidebarMinimized"
  (minimizedChange)="toggleMinimize($event)"

>
  <app-sidebar-nav
    [navItems]="navItems"
    [perfectScrollbar]
    [disabled]="appSidebar.minimized"
  >
  </app-sidebar-nav>
</app-sidebar>
